
export const ANCCountries = [


{
  country: "Spain",
  zone: [
    { city: "A CORUÑA", latitude: 43.371491, longitude: -8.3959697, gmtWinter: 1, gmtSummer: 2 },
    { city: "ALBACETE", latitude: 38.976208, longitude: -1.8457031, gmtWinter: 1, gmtSummer: 2 },
    { city: "ALACANT", latitude: 38.332751, longitude: -0.48339844, gmtWinter: 1, gmtSummer: 2 },
    { city: "ALMERIA", latitude: 36.826582, longitude: -2.4609375, gmtWinter: 1, gmtSummer: 2 },
    { city: "AVILA", latitude: 40.647026, longitude: -4.7021484, gmtWinter: 1, gmtSummer: 2 },
    { city: "BADAJOZ", latitude: 38.86509, longitude: -6.965332, gmtWinter: 1, gmtSummer: 2 },
    { city: "BARCELONA", latitude: 41.384777, longitude: 2.175293, gmtWinter: 1, gmtSummer: 2 },
    { city: "BILBO", latitude: 43.236933, longitude: -2.911377, gmtWinter: 1, gmtSummer: 2 },
    { city: "BURGOS", latitude: 42.325792, longitude: -3.7023926, gmtWinter: 1, gmtSummer: 2 },
    { city: "CACERES", latitude: 39.461361, longitude: -6.361084, gmtWinter: 1, gmtSummer: 2 },
    { city: "CADIZ", latitude: 36.527, longitude: -6.2731934, gmtWinter: 1, gmtSummer: 2 },
    { city: "CASTELLO", latitude: 39.985258, longitude: -0.010986328, gmtWinter: 1, gmtSummer: 2 },
    { city: "CEUTA", latitude: 35.87095, longitude: -5.3173828, gmtWinter: 1, gmtSummer: 2 },
    { city: "CDAD REAL", latitude: 38.959124, longitude: -3.9221191, gmtWinter: 1, gmtSummer: 2 },
    { city: "CORDOBA", latitude: 37.865892, longitude: -4.7680664, gmtWinter: 1, gmtSummer: 2 },
    { city: "CUENCA", latitude: 40.060976, longitude: -2.109375, gmtWinter: 1, gmtSummer: 2 },
    { city: "DONOSTI", latitude: 43.308925, longitude: -1.9885254, gmtWinter: 1, gmtSummer: 2 },
    { city: "GASTEIZ", latitude: 42.851538, longitude: -2.6696777, gmtWinter: 1, gmtSummer: 2 },
    { city: "GIRONA", latitude: 41.975555, longitude: 2.8234863, gmtWinter: 1, gmtSummer: 2 },
    { city: "GRANADA", latitude: 37.177534, longitude: -3.6035156, gmtWinter: 1, gmtSummer: 2 },
    { city: "GUADALAJAR", latitude: 40.622153, longitude: -3.1585693, gmtWinter: 1, gmtSummer: 2 },
    { city: "HUELVA", latitude: 37.247675, longitude: -6.9433594, gmtWinter: 1, gmtSummer: 2 },
    { city: "HUESCA", latitude: 42.138697, longitude: -0.40649414, gmtWinter: 1, gmtSummer: 2 },
    { city: "JAEN", latitude: 37.744367, longitude: -3.7902832, gmtWinter: 1, gmtSummer: 2 },
    { city: "LAS PALMAS", latitude: 28.120116, longitude: -15.435791, gmtWinter: 0, gmtSummer: 0 },
    { city: "LEON", latitude: 42.599876, longitude: -5.571752, gmtWinter: 1, gmtSummer: 2 },
    { city: "LLEIDA", latitude: 41.614152, longitude: 0.6257825, gmtWinter: 1, gmtSummer: 2 },
    { city: "LOGROÑO", latitude: 42.465776, longitude: -2.4499946, gmtWinter: 1, gmtSummer: 2 },
    { city: "LUGO", latitude: 43.012087, longitude: -7.5558514, gmtWinter: 1, gmtSummer: 2 },
    { city: "MADRID", latitude: 40.416741, longitude: -3.7032498, gmtWinter: 1, gmtSummer: 2 },
    { city: "MALAGA", latitude: 36.719646, longitude: -4.4200186, gmtWinter: 1, gmtSummer: 2 },
    { city: "MELILLA", latitude: 35.291937, longitude: -2.9384839, gmtWinter: 1, gmtSummer: 2 },
    { city: "MURCIA", latitude: 37.983474, longitude: -1.1298867, gmtWinter: 1, gmtSummer: 2 },
    { city: "OURENSE", latitude: 42.340009, longitude: -7.8646408, gmtWinter: 1, gmtSummer: 2 },
    { city: "OVIEDO", latitude: 43.360259, longitude: -5.8447584, gmtWinter: 1, gmtSummer: 2 },
    { city: "PALENCIA", latitude: 42.012458, longitude: -4.5311748, gmtWinter: 1, gmtSummer: 2 },
    { city: "P MALLORCA", latitude: 39.588475, longitude: 3.0102539, gmtWinter: 1, gmtSummer: 2 },
    { city: "PAMPLONA", latitude: 42.817991, longitude: -1.644215, gmtWinter: 1, gmtSummer: 2 },
    { city: "PONTEVEDRA", latitude: 42.433619, longitude: -8.648053, gmtWinter: 1, gmtSummer: 2 },
    { city: "SALAMANCA", latitude: 40.964972, longitude: -5.6630471, gmtWinter: 1, gmtSummer: 2 },
    { city: "S.TENERIFE", latitude: 28.291564, longitude: -16.62913, gmtWinter: 0, gmtSummer: 0 },
    { city: "SANTANDER", latitude: 43.46096, longitude: -3.8079336, gmtWinter: 1, gmtSummer: 2 },
    { city: "SEGOVIA", latitude: 40.949427, longitude: -4.1192092, gmtWinter: 1, gmtSummer: 2 },
    { city: "SEVILLA", latitude: 37.38264, longitude: -5.9962951, gmtWinter: 1, gmtSummer: 2 },
    { city: "SORIA", latitude: 41.763598, longitude: -2.4649206, gmtWinter: 1, gmtSummer: 2 },
    { city: "TARRAGONA", latitude: 41.119014, longitude: 1.2454572, gmtWinter: 1, gmtSummer: 2 },
    { city: "TERUEL", latitude: 40.34411, longitude: -1.1069096, gmtWinter: 1, gmtSummer: 2 },
    { city: "TOLEDO", latitude: 39.856777, longitude: -4.0244759, gmtWinter: 1, gmtSummer: 2 },
    { city: "VALENCIA", latitude: 39.470239, longitude: -0.3768049, gmtWinter: 1, gmtSummer: 2 },
    { city: "VALLADOLID", latitude: 41.652947, longitude: -4.7283877, gmtWinter: 1, gmtSummer: 2 },
    { city: "ZAMORA", latitude: 41.503347, longitude: -5.7462789, gmtWinter: 1, gmtSummer: 2 },
    { city: "ZARAGOZA", latitude: 41.65635, longitude: -0.8765662, gmtWinter: 1, gmtSummer: 2 }
  ]
},

{
  country: "Portugal",
  zone: [
    { city: "A HEROISMO", latitude: 38.658565, longitude: -27.215859, gmtWinter: -1, gmtSummer: 0 },
    { city: "FARO", latitude: 37.011033, longitude: -7.9101563, gmtWinter: 0, gmtSummer: 1 },
    { city: "FUNCHAL", latitude: 32.65, longitude: -16.916667, gmtWinter: 0, gmtSummer: 1 },
    { city: "LISBOA", latitude: 38.710947, longitude: -9.1186523, gmtWinter: 0, gmtSummer: 1 },
    { city: "P DELGADA", latitude: 37.7463, longitude: -25.66685, gmtWinter: -1, gmtSummer: 0 },
    { city: "PORTO", latitude: 41.13702, longitude: -8.6132813, gmtWinter: 0, gmtSummer: 1 },
    { city: "S GRACIOSA", latitude: 39.083333, longitude: -28.016667, gmtWinter: -1, gmtSummer: 0 }
  ]
},
{
  country: "France",
  zone: [
    { city: "AVIGNON", latitude: 43.949317, longitude: 4.805528, gmtWinter: 1, gmtSummer: 2 },
    { city: "BIARRITZ", latitude: 43.483152, longitude: -1.558626, gmtWinter: 1, gmtSummer: 2 },
    { city: "BORDEAUX", latitude: 44.837789, longitude: -0.57918, gmtWinter: 1, gmtSummer: 2 },
    { city: "BREST", latitude: 48.390394, longitude: -4.486076, gmtWinter: 1, gmtSummer: 2 },
    { city: "CLERM-FER", latitude: 49.376086, longitude: 2.414202, gmtWinter: 1, gmtSummer: 2 },
    { city: "GRENOBLE", latitude: 45.188529, longitude: 5.724524, gmtWinter: 1, gmtSummer: 2 },
    { city: "LE HAVRE", latitude: 49.49437, longitude: 0.107929, gmtWinter: 1, gmtSummer: 2 },
    { city: "LIMOGES", latitude: 45.833619, longitude: 1.261105, gmtWinter: 1, gmtSummer: 2 },
    { city: "LYON", latitude: 45.764043, longitude: 4.835659, gmtWinter: 1, gmtSummer: 2 },
    { city: "MARSELLA", latitude: 43.296482, longitude: 5.36978, gmtWinter: 1, gmtSummer: 2 },
    { city: "METZ", latitude: 49.119666, longitude: 6.176905, gmtWinter: 1, gmtSummer: 2 },
    { city: "NANTES", latitude: 47.218371, longitude: -1.553621, gmtWinter: 1, gmtSummer: 2 },
    { city: "NIZA", latitude: 43.696036, longitude: 7.265592, gmtWinter: 1, gmtSummer: 2 },
    { city: "ORLEANS", latitude: 47.902964, longitude: 1.909251, gmtWinter: 1, gmtSummer: 2 },
    { city: "PARIS", latitude: 48.856614, longitude: 2.3522219, gmtWinter: 1, gmtSummer: 2 },
    { city: "PERPIGNAN", latitude: 42.698684, longitude: 2.8958719, gmtWinter: 1, gmtSummer: 2 },
    { city: "RENNES", latitude: 48.113475, longitude: -1.675708, gmtWinter: 1, gmtSummer: 2 },
    { city: "ROUEN", latitude: 49.443232, longitude: 1.099971, gmtWinter: 1, gmtSummer: 2 },
    { city: "STRASBOURG", latitude: 48.583148, longitude: 7.747882, gmtWinter: 1, gmtSummer: 2 },
    { city: "TOULOUSE", latitude: 43.604652, longitude: 1.444209, gmtWinter: 1, gmtSummer: 2 },
    { city: "TOURS", latitude: 47.394144, longitude: 0.68484, gmtWinter: 1, gmtSummer: 2 }
  ]
}
  ,
{
  country: "Luxembourg",
  zone: [
    { city: "LUXEMBOURG", latitude: 49.611422, longitude: 6.144104, gmtWinter: 1, gmtSummer: 2 },
  ],
},
{
  country: "Belgium",
  zone: [
    { city: "ANTWERPEN", latitude: 51.219216, longitude: 4.4028818, gmtWinter: 1, gmtSummer: 2 },
    { city: "BRUGGE", latitude: 51.210836, longitude: 3.2248692, gmtWinter: 1, gmtSummer: 2 },
    { city: "BRUXELLES", latitude: 50.85034, longitude: 4.3517103, gmtWinter: 1, gmtSummer: 2 },
    { city: "CHARLEROI", latitude: 50.410809, longitude: 4.444643, gmtWinter: 1, gmtSummer: 2 },
    { city: "GENT", latitude: 51.05665, longitude: 3.72, gmtWinter: 1, gmtSummer: 2 },
    { city: "LIEGE", latitude: 50.632557, longitude: 5.5796662, gmtWinter: 1, gmtSummer: 2 },
  ],
},
{
  country: "Austria",
  zone: [
    { city: "GRAZ", latitude: 47.070714, longitude: 15.439504, gmtWinter: 1, gmtSummer: 2 },
    { city: "INNSBRUCK", latitude: 47.269212, longitude: 11.404102, gmtWinter: 1, gmtSummer: 2 },
    { city: "LINZ", latitude: 48.30694, longitude: 14.28583, gmtWinter: 1, gmtSummer: 2 },
    { city: "SALZBURG", latitude: 47.80949, longitude: 13.05501, gmtWinter: 1, gmtSummer: 2 },
    { city: "VIENA", latitude: 48.208174, longitude: 16.373819, gmtWinter: 1, gmtSummer: 2 },
  ],
},
{
  country: "Italy",
  zone: [
    { city: "AGRIGENTO", latitude: 37.311188, longitude: 13.576956, gmtWinter: 1, gmtSummer: 2 },
    { city: "ALESSANDR", latitude: 44.917361, longitude: 8.6462402, gmtWinter: 1, gmtSummer: 2 },
    { city: "ANCONA", latitude: 43.615857, longitude: 13.518757, gmtWinter: 1, gmtSummer: 2 },
    { city: "AOSTA", latitude: 45.735, longitude: 7.313234, gmtWinter: 1, gmtSummer: 2 },
    { city: "AREZZO", latitude: 43.471201, longitude: 11.863062, gmtWinter: 1, gmtSummer: 2 },
    { city: "ASTI", latitude: 44.900864, longitude: 8.206813, gmtWinter: 1, gmtSummer: 2 },
    { city: "BARI", latitude: 41.126001, longitude: 16.868379, gmtWinter: 1, gmtSummer: 2 },
    { city: "BELLUNO", latitude: 46.139964, longitude: 12.217591, gmtWinter: 1, gmtSummer: 2 },
    { city: "BERGAMO", latitude: 45.694903, longitude: 9.6699528, gmtWinter: 1, gmtSummer: 2 },
    { city: "BOLOGNA", latitude: 44.494219, longitude: 11.346481, gmtWinter: 1, gmtSummer: 2 },
    { city: "BOLZANO", latitude: 46.496715, longitude: 11.358005, gmtWinter: 1, gmtSummer: 2 },
    { city: "BRESCIA", latitude: 45.53983, longitude: 10.222957, gmtWinter: 1, gmtSummer: 2 },
    { city: "BRINDISI", latitude: 40.636175, longitude: 17.938991, gmtWinter: 1, gmtSummer: 2 },
    { city: "CAGLIARI", latitude: 39.215458, longitude: 9.1092282, gmtWinter: 1, gmtSummer: 2 },
    { city: "CAMPOBASSO", latitude: 41.560086, longitude: 14.664799, gmtWinter: 1, gmtSummer: 2 },
    { city: "CASERTA", latitude: 41.075415, longitude: 14.332195, gmtWinter: 1, gmtSummer: 2 },
    { city: "CATANIA", latitude: 37.502482, longitude: 15.087834, gmtWinter: 1, gmtSummer: 2 },
    { city: "CATANZARO", latitude: 38.910599, longitude: 16.587679, gmtWinter: 1, gmtSummer: 2 },
    { city: "CHIETI", latitude: 42.351793, longitude: 14.167151, gmtWinter: 1, gmtSummer: 2 },
    { city: "COMO", latitude: 45.811988, longitude: 9.0855639, gmtWinter: 1, gmtSummer: 2 },
    { city: "CREMONA", latitude: 45.133497, longitude: 10.026135, gmtWinter: 1, gmtSummer: 2 },
    { city: "CUNEO", latitude: 44.388799, longitude: 7.5471107, gmtWinter: 1, gmtSummer: 2 },
    { city: "FIRENZE", latitude: 43.768732, longitude: 11.256901, gmtWinter: 1, gmtSummer: 2 },
    { city: "FOGGIA", latitude: 41.462335, longitude: 15.5447, gmtWinter: 1, gmtSummer: 2 },
    { city: "FROSINONE", latitude: 41.640137, longitude: 13.351902, gmtWinter: 1, gmtSummer: 2 },
    { city: "GENOVA", latitude: 44.407062, longitude: 8.9339889, gmtWinter: 1, gmtSummer: 2 },
    { city: "IMPERIA", latitude: 43.941866, longitude: 7.8286368, gmtWinter: 1, gmtSummer: 2 },
    { city: "LA SPEZIA", latitude: 44.106737, longitude: 9.8292189, gmtWinter: 1, gmtSummer: 2 },
    { city: "L.AQUILA", latitude: 42.350698, longitude: 13.399934, gmtWinter: 1, gmtSummer: 2 },
    { city: "LATINA", latitude: 41.467597, longitude: 12.9037, gmtWinter: 1, gmtSummer: 2 },
    { city: "LECCE", latitude: 40.353291, longitude: 18.174015, gmtWinter: 1, gmtSummer: 2 },
    { city: "LECCO", latitude: 45.852983, longitude: 9.3900705, gmtWinter: 1, gmtSummer: 2 },
    { city: "LIVORNO", latitude: 43.551876, longitude: 10.308011, gmtWinter: 1, gmtSummer: 2 },
    { city: "LUCCA", latitude: 43.843014, longitude: 10.507994, gmtWinter: 1, gmtSummer: 2 },
    { city: "MASSA-CAR", latitude: 44.079337, longitude: 10.101236, gmtWinter: 1, gmtSummer: 2 },
    { city: "MESSINA", latitude: 38.192332, longitude: 15.555523, gmtWinter: 1, gmtSummer: 2 },
    { city: "MILANO", latitude: 45.463689, longitude: 9.1881408, gmtWinter: 1, gmtSummer: 2 },
    { city: "MODENA", latitude: 44.64708, longitude: 10.92522, gmtWinter: 1, gmtSummer: 2 },
    { city: "NAPOLI", latitude: 40.840097, longitude: 14.251636, gmtWinter: 1, gmtSummer: 2 },
    { city: "NOVARA", latitude: 45.445084, longitude: 8.618671, gmtWinter: 1, gmtSummer: 2 },
    { city: "NUORO", latitude: 40.320998, longitude: 9.3303647, gmtWinter: 1, gmtSummer: 2 },
    { city: "PADOVA", latitude: 45.409568, longitude: 11.876589, gmtWinter: 1, gmtSummer: 2 },
    { city: "PALERMO", latitude: 38.115619, longitude: 13.361376, gmtWinter: 1, gmtSummer: 2 },
    { city: "PARMA", latitude: 44.807866, longitude: 10.329548, gmtWinter: 1, gmtSummer: 2 },
    { city: "PAVIA", latitude: 45.185888, longitude: 9.1565627, gmtWinter: 1, gmtSummer: 2 },
    { city: "PERUGIA", latitude: 43.110701, longitude: 12.389172, gmtWinter: 1, gmtSummer: 2 },
    { city: "PESARO", latitude: 43.912069, longitude: 12.915744, gmtWinter: 1, gmtSummer: 2 },
    { city: "PESCARA", latitude: 42.464826, longitude: 14.214095, gmtWinter: 1, gmtSummer: 2 },
    { city: "PIACENZA", latitude: 45.053773, longitude: 9.6951421, gmtWinter: 1, gmtSummer: 2 },
    { city: "PISA", latitude: 43.716135, longitude: 10.396584, gmtWinter: 1, gmtSummer: 2 },
    { city: "PISTOIA", latitude: 43.932155, longitude: 10.918523, gmtWinter: 1, gmtSummer: 2 },
    { city: "PORDENONE", latitude: 45.962652, longitude: 12.655044, gmtWinter: 1, gmtSummer: 2 },
    { city: "POTENZA", latitude: 40.637242, longitude: 15.802221, gmtWinter: 1, gmtSummer: 2 },
    { city: "PRATO", latitude: 43.879699, longitude: 11.096312, gmtWinter: 1, gmtSummer: 2 },
    { city: "RAGUSA", latitude: 36.925913, longitude: 14.728504, gmtWinter: 1, gmtSummer: 2 },
    { city: "RG. CALAB", latitude: 38.11469, longitude: 15.650137, gmtWinter: 1, gmtSummer: 2 },
    { city: "RG. EMILIA", latitude: 44.69623, longitude: 10.627794, gmtWinter: 1, gmtSummer: 2 },
    { city: "RIETI", latitude: 42.403056, longitude: 12.861179, gmtWinter: 1, gmtSummer: 2 },
    { city: "RIMINI", latitude: 44.060917, longitude: 12.566301, gmtWinter: 1, gmtSummer: 2 },
    { city: "ROMA", latitude: 41.895466, longitude: 12.482324, gmtWinter: 1, gmtSummer: 2 },
    { city: "ROVIGO", latitude: 45.070737, longitude: 11.789796, gmtWinter: 1, gmtSummer: 2 },
    { city: "SALERNO", latitude: 40.677957, longitude: 14.765912, gmtWinter: 1, gmtSummer: 2 },
    { city: "SASSARI", latitude: 40.727165, longitude: 8.5584684, gmtWinter: 1, gmtSummer: 2 },
    { city: "SAVONA", latitude: 44.31107, longitude: 8.4772463, gmtWinter: 1, gmtSummer: 2 },
    { city: "SIENA", latitude: 43.318661, longitude: 11.330514, gmtWinter: 1, gmtSummer: 2 },
    { city: "SIRACUSA", latitude: 37.066455, longitude: 15.284428, gmtWinter: 1, gmtSummer: 2 },
    { city: "SONDRIO", latitude: 46.17126, longitude: 9.8693336, gmtWinter: 1, gmtSummer: 2 },
    { city: "TERNI", latitude: 42.560219, longitude: 12.646781, gmtWinter: 1, gmtSummer: 2 },
    { city: "TORINO", latitude: 45.070562, longitude: 7.6866186, gmtWinter: 1, gmtSummer: 2 },
    { city: "TRAPANI", latitude: 38.018588, longitude: 12.514634, gmtWinter: 1, gmtSummer: 2 },
    { city: "TRENTO", latitude: 46.066712, longitude: 11.119059, gmtWinter: 1, gmtSummer: 2 },
    { city: "TREVISO", latitude: 45.666286, longitude: 12.242072, gmtWinter: 1, gmtSummer: 2 },
    { city: "TRIESTE", latitude: 45.65363, longitude: 13.778407, gmtWinter: 1, gmtSummer: 2 },
    { city: "UDINE", latitude: 46.064942, longitude: 13.230725, gmtWinter: 1, gmtSummer: 2 },
    { city: "VARESE", latitude: 45.817605, longitude: 8.8263844, gmtWinter: 1, gmtSummer: 2 },
    { city: "VENEZIA", latitude: 45.434336, longitude: 12.338784, gmtWinter: 1, gmtSummer: 2 },
    { city: "VERCELLI", latitude: 45.321111, longitude: 8.4262359, gmtWinter: 1, gmtSummer: 2 },
    { city: "VERONA", latitude: 45.438367, longitude: 10.991748, gmtWinter: 1, gmtSummer: 2 },
    { city: "VICENZA", latitude: 45.545905, longitude: 11.540307, gmtWinter: 1, gmtSummer: 2 },
    { city: "VITERBO", latitude: 42.417379, longitude: 12.104854, gmtWinter: 1, gmtSummer: 2 },
  ],
},
{
  country: "Switzerland",
  zone: [
    { city: "BERN", latitude: 46.947922, longitude: 7.4446085, gmtWinter: 1, gmtSummer: 2 },
    { city: "GENEVA", latitude: 46.198392, longitude: 6.1422961, gmtWinter: 1, gmtSummer: 2 },
    { city: "ZURICH", latitude: 47.36865, longitude: 8.5391825, gmtWinter: 1, gmtSummer: 2 },
  ],
},
{
  country: "Germany",
  zone: [
    { city: "BERLIN", latitude: 52.523405, longitude: 13.4114, gmtWinter: 1, gmtSummer: 2 },
    { city: "BREMEN", latitude: 53.074981, longitude: 8.807081, gmtWinter: 1, gmtSummer: 2 },
    { city: "DORTMUND", latitude: 51.512054, longitude: 7.4635729, gmtWinter: 1, gmtSummer: 2 },
    { city: "DRESDEN", latitude: 51.050958, longitude: 13.733658, gmtWinter: 1, gmtSummer: 2 },
    { city: "DUSSELDORF", latitude: 51.224943, longitude: 6.7756524, gmtWinter: 1, gmtSummer: 2 },
    { city: "ERFURT", latitude: 50.973735, longitude: 11.022399, gmtWinter: 1, gmtSummer: 2 },
    { city: "FRANKFURT", latitude: 50.111512, longitude: 8.6805059, gmtWinter: 1, gmtSummer: 2 },
    { city: "FREIBURG", latitude: 47.997186, longitude: 7.8537668, gmtWinter: 1, gmtSummer: 2 },
    { city: "HAMBURG", latitude: 53.553407, longitude: 9.9921962, gmtWinter: 1, gmtSummer: 2 },
    { city: "HANNOVER", latitude: 52.372068, longitude: 9.7356861, gmtWinter: 1, gmtSummer: 2 },
    { city: "KARSLRUHE", latitude: 49.008085, longitude: 8.4037563, gmtWinter: 1, gmtSummer: 2 },
    { city: "KASSEL", latitude: 51.318928, longitude: 9.49601, gmtWinter: 1, gmtSummer: 2 },
    { city: "KIEL", latitude: 54.322684, longitude: 10.13586, gmtWinter: 1, gmtSummer: 2 },
    { city: "KOLN", latitude: 50.940664, longitude: 6.9599115, gmtWinter: 1, gmtSummer: 2 },
    { city: "LEIPZIG", latitude: 51.33968, longitude: 12.371301, gmtWinter: 1, gmtSummer: 2 },
    { city: "MAGDEBURG", latitude: 52.130956, longitude: 11.636701, gmtWinter: 1, gmtSummer: 2 },
    { city: "MANNHEIM", latitude: 49.484677, longitude: 8.476724, gmtWinter: 1, gmtSummer: 2 },
    { city: "MUNCHEN", latitude: 48.139127, longitude: 11.580186, gmtWinter: 1, gmtSummer: 2 },
    { city: "NURNBERG", latitude: 49.45052, longitude: 11.08048, gmtWinter: 1, gmtSummer: 2 },
    { city: "REGENSBURG", latitude: 49.016491, longitude: 12.100904, gmtWinter: 1, gmtSummer: 2 },
    { city: "ROSTOK", latitude: 54.090133, longitude: 12.132956, gmtWinter: 1, gmtSummer: 2 },
    { city: "SAARBRUCK", latitude: 49.234851, longitude: 6.9944016, gmtWinter: 1, gmtSummer: 2 },
    { city: "SCHWERING", latitude: 49.744755, longitude: 6.609804, gmtWinter: 1, gmtSummer: 2 },
    { city: "STUTTGART", latitude: 48.777106, longitude: 9.1807688, gmtWinter: 1, gmtSummer: 2 },
  ],
},
{
  country: "UK",
  zone: [
    { city: "ABERYSTWY", latitude: 52.415303, longitude: -4.08292, gmtWinter: 0, gmtSummer: 1 },
    { city: "BELFAST", latitude: 54.597443, longitude: -5.9340683, gmtWinter: 0, gmtSummer: 1 },
    { city: "BIRMINGHAM", latitude: 52.486243, longitude: -1.890401, gmtWinter: 0, gmtSummer: 1 },
    { city: "BRISTOL", latitude: 51.454513, longitude: -2.58791, gmtWinter: 0, gmtSummer: 1 },
    { city: "CAMBRIDGE", latitude: 52.205337, longitude: 0.121817, gmtWinter: 0, gmtSummer: 1 },
    { city: "CARLISLE", latitude: 54.892473, longitude: -2.932931, gmtWinter: 0, gmtSummer: 1 },
    { city: "DOUGLAS", latitude: 54.151971, longitude: -4.485244, gmtWinter: 0, gmtSummer: 1 },
    { city: "DOVER", latitude: 51.126371, longitude: 1.316198, gmtWinter: 0, gmtSummer: 1 },
    { city: "DUNDEE", latitude: 56.462018, longitude: -2.970721, gmtWinter: 0, gmtSummer: 1 },
    { city: "F WILLIAM", latitude: 56.819817, longitude: -5.105218, gmtWinter: 0, gmtSummer: 1 },
    { city: "GLASGOW", latitude: 55.864237, longitude: -4.251806, gmtWinter: 0, gmtSummer: 1 },
    { city: "INVERNESS", latitude: 57.477773, longitude: -4.224721, gmtWinter: 0, gmtSummer: 1 },
    { city: "JO GROATS", latitude: 58.6373368, longitude: -3.0688997, gmtWinter: 0, gmtSummer: 1 },
    { city: "LEEDS", latitude: 53.801279, longitude: -1.548567, gmtWinter: 0, gmtSummer: 1 },
    { city: "LINCOLN", latitude: 53.230688, longitude: -0.540579, gmtWinter: 0, gmtSummer: 1 },
    { city: "LIVERPOOL", latitude: 53.41154, longitude: -2.990116, gmtWinter: 0, gmtSummer: 1 },
    { city: "LONDON", latitude: 51.508129, longitude: -0.128005, gmtWinter: 0, gmtSummer: 1 },
    { city: "LONDONDER", latitude: 54.996612, longitude: -7.3085748, gmtWinter: 0, gmtSummer: 1 },
    { city: "NEWCASTLE", latitude: 54.978252, longitude: -1.61778, gmtWinter: 0, gmtSummer: 1 },
    { city: "NOTTINGHAM", latitude: 52.95477, longitude: -1.158086, gmtWinter: 0, gmtSummer: 1 },
    { city: "NORWICH", latitude: 52.630886, longitude: 1.297355, gmtWinter: 0, gmtSummer: 1 },
    { city: "PLYMOUTH", latitude: 50.371916, longitude: -4.1360198, gmtWinter: 0, gmtSummer: 1 },
    { city: "SOUTHAMPTO", latitude: 50.9097, longitude: -1.4043509, gmtWinter: 0, gmtSummer: 1 },
    { city: "SWANSEA", latitude: 51.62144, longitude: -3.943646, gmtWinter: 0, gmtSummer: 1 }
  ]
},
{
  country: "Ireland",
  zone: [
    { city: "BRAY", latitude: 53.200903, longitude: -6.1110741, gmtWinter: 0, gmtSummer: 1 },
    { city: "CORK", latitude: 51.897167, longitude: -8.477869, gmtWinter: 0, gmtSummer: 1 },
    { city: "DUBLIN", latitude: 53.344104, longitude: -6.2674937, gmtWinter: 0, gmtSummer: 1 },
    { city: "DUNDALK", latitude: 53.9979451, longitude: -6.405957, gmtWinter: 0, gmtSummer: 1 },
    { city: "GALWAY", latitude: 53.27058, longitude: -9.065248, gmtWinter: 0, gmtSummer: 1 },
    { city: "LIMERICK", latitude: 52.6680204, longitude: -8.6304975, gmtWinter: 0, gmtSummer: 1 },
    { city: "SLIGO", latitude: 54.270601, longitude: -8.4716438, gmtWinter: 0, gmtSummer: 1 },
    { city: "WATERFORD", latitude: 52.2566667, longitude: -7.1291667, gmtWinter: 0, gmtSummer: 1 }
  ]
},

{
  country: "Czech Republic",
  zone: [
    { city: "BRNO", latitude: 49.192051, longitude: 16.613191, gmtWinter: 1, gmtSummer: 2 },
    { city: "CESKE BUD", latitude: 48.9756578, longitude: 14.480255, gmtWinter: 1, gmtSummer: 2 },
    { city: "HRADEC KR", latitude: 50.2103605, longitude: 15.825211, gmtWinter: 1, gmtSummer: 2 },
    { city: "KARLOVY V", latitude: 50.232205, longitude: 12.871277, gmtWinter: 1, gmtSummer: 2 },
    { city: "LIBEREC", latitude: 50.76702, longitude: 15.056135, gmtWinter: 1, gmtSummer: 2 },
    { city: "OLOMOUC", latitude: 49.595388, longitude: 17.251872, gmtWinter: 1, gmtSummer: 2 },
    { city: "OSTRAVA", latitude: 49.841271, longitude: 18.290248, gmtWinter: 1, gmtSummer: 2 },
    { city: "PLZEN", latitude: 49.747485, longitude: 13.377604, gmtWinter: 1, gmtSummer: 2 },
    { city: "PRAHA", latitude: 50.087811, longitude: 14.42046, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Norway",
  zone: [
    { city: "ÅLESUND", latitude: 62.47094, longitude: 6.1546356, gmtWinter: 1, gmtSummer: 2 },
    { city: "BERGEN", latitude: 60.388072, longitude: 5.3318512, gmtWinter: 1, gmtSummer: 2 },
    { city: "BODØ", latitude: 67.279999, longitude: 14.40501, gmtWinter: 1, gmtSummer: 2 },
    { city: "DRAMMEN", latitude: 59.745106, longitude: 10.213453, gmtWinter: 1, gmtSummer: 2 },
    { city: "HAUGESUND", latitude: 59.424254, longitude: 5.2626586, gmtWinter: 1, gmtSummer: 2 },
    { city: "KR SAND", latitude: 58.144695, longitude: 7.9982841, gmtWinter: 1, gmtSummer: 2 },
    { city: "KR SUND", latitude: 63.11944, longitude: 7.713596, gmtWinter: 1, gmtSummer: 2 },
    { city: "LARVIK", latitude: 59.053276, longitude: 10.035172, gmtWinter: 1, gmtSummer: 2 },
    { city: "LILLEHAMM", latitude: 61.113304, longitude: 10.464359, gmtWinter: 1, gmtSummer: 2 },
    { city: "MO I RANA", latitude: 66.312777, longitude: 14.142785, gmtWinter: 1, gmtSummer: 2 },
    { city: "MOLDE", latitude: 62.740539, longitude: 7.1640589, gmtWinter: 1, gmtSummer: 2 },
    { city: "NARVIK", latitude: 68.438498, longitude: 17.427261, gmtWinter: 1, gmtSummer: 2 },
    { city: "OSLO", latitude: 59.91382, longitude: 10.738741, gmtWinter: 1, gmtSummer: 2 },
    { city: "RØROS", latitude: 62.57805, longitude: 11.391953, gmtWinter: 1, gmtSummer: 2 },
    { city: "SARPSBORG", latitude: 59.284759, longitude: 11.106083, gmtWinter: 1, gmtSummer: 2 },
    { city: "STAVANGER", latitude: 58.964424, longitude: 5.72626, gmtWinter: 1, gmtSummer: 2 },
    { city: "STEINKJÆR", latitude: 64.02056, longitude: 11.497178, gmtWinter: 1, gmtSummer: 2 },
    { city: "TROMSØ", latitude: 69.649205, longitude: 18.955324, gmtWinter: 1, gmtSummer: 2 },
    { city: "TRONDHEIM", latitude: 63.43463, longitude: 10.398455, gmtWinter: 1, gmtSummer: 2 }
  ]
},

{
  country: "Sweden",
  zone: [
    { city: "GAVLE", latitude: 60.674616, longitude: 17.141831, gmtWinter: 1, gmtSummer: 2 },
    { city: "GOTEBORG", latitude: 57.696994, longitude: 11.9865, gmtWinter: 1, gmtSummer: 2 },
    { city: "HALMSTAD", latitude: 56.67397, longitude: 12.85729, gmtWinter: 1, gmtSummer: 2 },
    { city: "HAPARANDA", latitude: 65.8333333, longitude: 24.1333333, gmtWinter: 1, gmtSummer: 2 },
    { city: "HELSINGB", latitude: 56.046872, longitude: 12.695286, gmtWinter: 1, gmtSummer: 2 },
    { city: "JOKKMOKK", latitude: 66.60665, longitude: 19.82324, gmtWinter: 1, gmtSummer: 2 },
    { city: "JONKOPING", latitude: 57.781798, longitude: 14.15851, gmtWinter: 1, gmtSummer: 2 },
    { city: "KALMAR", latitude: 56.661445, longitude: 16.362723, gmtWinter: 1, gmtSummer: 2 },
    { city: "KARLSTAD", latitude: 59.378236, longitude: 13.50422, gmtWinter: 1, gmtSummer: 2 },
    { city: "KIRUNA", latitude: 67.8166667, longitude: 20.3333333, gmtWinter: 1, gmtSummer: 2 },
    { city: "KRISTIANS", latitude: 56.02249, longitude: 14.14483, gmtWinter: 1, gmtSummer: 2 },
    { city: "LULEA", latitude: 65.584157, longitude: 22.154749, gmtWinter: 1, gmtSummer: 2 },
    { city: "MALMO", latitude: 55.603331, longitude: 13.001303, gmtWinter: 1, gmtSummer: 2 },
    { city: "MORA", latitude: 61.006552, longitude: 14.537554, gmtWinter: 1, gmtSummer: 2 },
    { city: "NORRKOPING", latitude: 58.594702, longitude: 16.183607, gmtWinter: 1, gmtSummer: 2 },
    { city: "OREBRO", latitude: 59.26692, longitude: 15.22371, gmtWinter: 1, gmtSummer: 2 },
    { city: "OSTERSUND", latitude: 63.161781, longitude: 14.662227, gmtWinter: 1, gmtSummer: 2 },
    { city: "PAJALA", latitude: 67.2, longitude: 23.3666667, gmtWinter: 1, gmtSummer: 2 },
    { city: "SKELLEFTEA", latitude: 64.751094, longitude: 20.953695, gmtWinter: 1, gmtSummer: 2 },
    { city: "STOCKHOLM", latitude: 59.332788, longitude: 18.064488, gmtWinter: 1, gmtSummer: 2 },
    { city: "SUNDSVALL", latitude: 62.39083, longitude: 17.30691, gmtWinter: 1, gmtSummer: 2 },
    { city: "UMEA", latitude: 63.82602, longitude: 20.268904, gmtWinter: 1, gmtSummer: 2 },
    { city: "UPPSALA", latitude: 59.858143, longitude: 17.644586, gmtWinter: 1, gmtSummer: 2 },
    { city: "VAXJO", latitude: 56.87697, longitude: 14.80918, gmtWinter: 1, gmtSummer: 2 },
    { city: "VILHELMINA", latitude: 64.624471, longitude: 16.655497, gmtWinter: 1, gmtSummer: 2 }
  ]
},

{
  country: "Iceland",
  zone: [
    { city: "AKUREYRI", latitude: 65.6833333, longitude: -18.1, gmtWinter: 0, gmtSummer: 0 },
    { city: "HAFNARFJÖR", latitude: 64.0666667, longitude: -21.95, gmtWinter: 0, gmtSummer: 0 },
    { city: "KEFLAVIK", latitude: 64.0011111, longitude: -22.5519444, gmtWinter: 0, gmtSummer: 0 },
    { city: "KOPAVOGUR", latitude: 64.1111111, longitude: -21.9055556, gmtWinter: 0, gmtSummer: 0 },
    { city: "REIKIAVIK", latitude: 64.1333333, longitude: -21.9333333, gmtWinter: 0, gmtSummer: 0 }
  ]
},

{
  country: "Finland", // Error en las tablas ---- dato correcto gmtWinter: 2, gmtSummer: 3
  zone: [
    { city: "HELSINKI", latitude: 60.169845, longitude: 24.938551, gmtWinter: 1, gmtSummer: 2 },
    { city: "JOENSUU", latitude: 62.600986, longitude: 29.763547, gmtWinter: 1, gmtSummer: 2 },
    { city: "JYVASKYLA", latitude: 62.242642, longitude: 25.747383, gmtWinter: 1, gmtSummer: 2 },
    { city: "KUOPIO", latitude: 62.898011, longitude: 27.678231, gmtWinter: 1, gmtSummer: 2 },
    { city: "LAPEENRA", latitude: 61.054941, longitude: 28.189626, gmtWinter: 1, gmtSummer: 2 },
    { city: "OULU", latitude: 65.012057, longitude: 25.465186, gmtWinter: 1, gmtSummer: 2 },
    { city: "RAUMA", latitude: 61.128095, longitude: 21.510979, gmtWinter: 1, gmtSummer: 2 },
    { city: "TAMPERE", latitude: 61.49816, longitude: 23.761055, gmtWinter: 1, gmtSummer: 2 },
    { city: "TURKU", latitude: 60.449249, longitude: 22.259239, gmtWinter: 1, gmtSummer: 2 },
    { city: "VAASA", latitude: 63.095141, longitude: 21.616513, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Denmark",
  zone: [
    { city: "AALBORG", latitude: 57.028811, longitude: 9.917771, gmtWinter: 1, gmtSummer: 2 },
    { city: "AARHUS", latitude: 56.162939, longitude: 10.203921, gmtWinter: 1, gmtSummer: 2 },
    { city: "COPENHAGU", latitude: 55.676097, longitude: 12.568337, gmtWinter: 1, gmtSummer: 2 },
    { city: "HERNING", latitude: 56.138557, longitude: 8.967322, gmtWinter: 1, gmtSummer: 2 },
    { city: "ODENSE", latitude: 55.403756, longitude: 10.40237, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Netherlands",
  zone: [
    { city: "AMSTERDAM", latitude: 52.370216, longitude: 4.8951679, gmtWinter: 1, gmtSummer: 2 },
    { city: "GRONINGA", latitude: 53.219384, longitude: 6.5665018, gmtWinter: 1, gmtSummer: 2 },
    { city: "ROTERDAM", latitude: 51.924216, longitude: 4.481776, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Slovakia",
  zone: [
    { city: "BANSKA", latitude: 48.759086, longitude: 19.160156, gmtWinter: 1, gmtSummer: 2 },
    { city: "BRATISLAVA", latitude: 48.146239, longitude: 17.107262, gmtWinter: 1, gmtSummer: 2 },
    { city: "KOSICE", latitude: 48.720996, longitude: 21.257748, gmtWinter: 1, gmtSummer: 2 },
    { city: "NITRA", latitude: 48.309892, longitude: 18.085876, gmtWinter: 1, gmtSummer: 2 },
    { city: "PRESOV", latitude: 49.002474, longitude: 21.239684, gmtWinter: 1, gmtSummer: 2 },
    { city: "TRENCIN", latitude: 48.893946, longitude: 18.03785, gmtWinter: 1, gmtSummer: 2 },
    { city: "ZILINA", latitude: 49.219548, longitude: 18.741273, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Greece",
  zone: [
    { city: "ATHENAS", latitude: 37.975336, longitude: 23.73615, gmtWinter: 1, gmtSummer: 2 },
    { city: "IRAKLIO", latitude: 35.329162, longitude: 25.138526, gmtWinter: 2, gmtSummer: 3 },
    { city: "KAVALA", latitude: 40.936499, longitude: 24.409477, gmtWinter: 2, gmtSummer: 3 },
    { city: "LARISSA", latitude: 39.632098, longitude: 22.419935, gmtWinter: 2, gmtSummer: 3 },
    { city: "PIREAS", latitude: 37.950902, longitude: 23.641103, gmtWinter: 2, gmtSummer: 3 },
    { city: "PATRA", latitude: 38.254465, longitude: 21.737067, gmtWinter: 2, gmtSummer: 3 },
    { city: "THESSALONI", latitude: 40.63935, longitude: 22.944607, gmtWinter: 2, gmtSummer: 3 },
    { city: "VOLOS", latitude: 39.364617, longitude: 22.933212, gmtWinter: 2, gmtSummer: 3 }
  ]
},
{
  country: "Malta",
  zone: [
    { city: "LA VALETA", latitude: 35.8989085, longitude: 14.5145528, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Cyprus",
  zone: [
    { city: "NICOSIA", latitude: 35.166667, longitude: 33.366667, gmtWinter: 1, gmtSummer: 2 },
    { city: "LIMASSOL", latitude: 34.7071301, longitude: 33.0226174, gmtWinter: 1, gmtSummer: 2 },
    { city: "LARNACA", latitude: 34.9166667, longitude: 33.6333333, gmtWinter: 1 , gmtSummer: 2 },
    { city: "PAPHOS", latitude: 34.7720133, longitude: 32.4297369, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Czech Republic",
  zone: [
    { city: "BRNO", latitude: 49.192051, longitude: 16.613191, gmt: 1 },
    { city: "CESKE BUD", latitude: 48.9756578, longitude: 14.480255, gmt: 1 },
    { city: "HRADEC KR", latitude: 50.2103605, longitude: 15.825211, gmt: 1 },
    { city: "KARLOVY V", latitude: 50.232205, longitude: 12.871277, gmt: 1 },
    { city: "LIBEREC", latitude: 50.76702, longitude: 15.056135, gmt: 1 },
    { city: "OLOMOUC", latitude: 49.595388, longitude: 17.251872, gmt: 1 },
    { city: "OSTRAVA", latitude: 49.841271, longitude: 18.290248, gmt: 1 },
    { city: "PLZEN", latitude: 49.747485, longitude: 13.377604, gmt: 1 },
    { city: "PRAHA", latitude: 50.087811, longitude: 14.42046, gmt: 1 }
  ]
},
{
  country: "AUS -DST",
  zone: [
    { city: "ADELAIDE", latitude: -34.928726, longitude: 138.59995, gmtWinter: 9.5, gmtSummer: 10.5 },
    { city: "CANBERRA", latitude: -35.282, longitude: 149.12868, gmtWinter: 10, gmtSummer: 11 },
    { city: "HOBART", latitude: -42.881903, longitude: 147.32381, gmtWinter: 10, gmtSummer: 11 },
    { city: "MELBOURNE", latitude: -37.813187, longitude: 144.96298, gmtWinter: 10, gmtSummer: 11 },
    { city: "SYDNEY", latitude: -33.873651, longitude: 151.20689, gmtWinter: 10, gmtSummer: 11 }
  ]
},
{
  country: "AUS -NODST",
  zone: [
    { city: "ALICE SPR", latitude: -23.69959, longitude: 133.880639, gmtWinter: 9.5, gmtSummer: 9.5 },
    { city: "BRISBANE", latitude: -27.470933, longitude: 153.0235, gmtWinter: 10, gmtSummer: 10 },
    { city: "BROOME", latitude: -17.951221, longitude: 122.24433, gmtWinter: 8, gmtSummer: 8 },
    { city: "CAIRNS", latitude: -16.923399, longitude: 145.77385, gmtWinter: 10, gmtSummer: 10 },
    { city: "DAMPIER", latitude: -20.663799, longitude: 116.70846, gmtWinter: 8, gmtSummer: 8 },
    { city: "DARWIN", latitude: -12.46282, longitude: 130.84177, gmtWinter: 9.5, gmtSummer: 9.5 },
    { city: "PERTH", latitude: -31.952854, longitude: 115.85734, gmtWinter: 8, gmtSummer: 8 },
  ]
},
{
  country: "New Zealand",
  zone: [
    { city: "AUCKLAND", latitude: -36.84846, longitude: 174.76333, gmtWinter: 12, gmtSummer: 13 },
    { city: "CHRISTCHUR", latitude: -43.532054, longitude: 172.63623, gmtWinter: 12, gmtSummer: 13 },
    { city: "GISBORNE", latitude: -38.662334, longitude: 178.01765, gmtWinter: 12, gmtSummer: 13 },
    { city: "INVERCARG", latitude: -46.446942, longitude: 168.37646, gmtWinter: 12, gmtSummer: 13 },
    { city: "KAIKOURA", latitude: -42.400817, longitude: 173.68139, gmtWinter: 12, gmtSummer: 13 },
    { city: "KAITAIA", latitude: -35.11733, longitude: 173.26756, gmtWinter: 12, gmtSummer: 13 },
    { city: "N PLYMOUTH", latitude: -39.055625, longitude: 174.07523, gmtWinter: 12, gmtSummer: 13 },
    { city: "NAPIER", latitude: -39.492844, longitude: 176.91202, gmtWinter: 12, gmtSummer: 13 },
    { city: "QUEENSTOW", latitude: -45.031162, longitude: 168.66264, gmtWinter: 12, gmtSummer: 13 },
    { city: "ROTOURA", latitude: -38.136848, longitude: 176.24975, gmtWinter: 12, gmtSummer: 13 },
    { city: "WELLINGTON", latitude: -41.28646, longitude: 174.77624, gmtWinter: 12, gmtSummer: 13 },
    { city: "WESTPORT", latitude: -41.754522, longitude: 171.60589, gmtWinter: 12, gmtSummer: 13 }
  ]
},

{
  country: "Algeria",
  zone: [
    { city: "ANNABA", latitude: 36.902859, longitude: 7.755543, gmtWinter: 1, gmtSummer: 1 },
    { city: "ALGER", latitude: 36.752887, longitude: 3.042048, gmtWinter: 1, gmtSummer: 1 },
    { city: "BEJAIA", latitude: 36.75, longitude: 5.0666667, gmtWinter: 1, gmtSummer: 1 },
    { city: "AIN SALAH", latitude: 27.194189, longitude: 2.473933, gmtWinter: 1, gmtSummer: 1 },
    { city: "MOSTAGANEM", latitude: 35.933333, longitude: 0.0833333, gmtWinter: 1, gmtSummer: 1 },
    { city: "ORAN", latitude: 35.696944, longitude: -0.6330556, gmtWinter: 1, gmtSummer: 1 },
    { city: "OUARGLA", latitude: 31.96298, longitude: 5.342011, gmtWinter: 1, gmtSummer: 1 },
    { city: "SETIF", latitude: 36.18898, longitude: 5.414416, gmtWinter: 1, gmtSummer: 1 },
    { city: "TAMANRASS", latitude: 22.785, longitude: 5.5227778, gmtWinter: 1, gmtSummer: 1 },
    { city: "TIZI OUZOU", latitude: 36.716667, longitude: 4.05, gmtWinter: 1, gmtSummer: 1 }
  ]
},
{
  country: "Morocco",
  zone: [
    { city: "AGADIR", latitude: 30.4, longitude: -9.6 , gmtWinter: 1, gmtSummer: 0 },
    { city: "CASABLANC", latitude: 33.605381, longitude: -7.631949, gmtWinter: 1, gmtSummer: 0 },
    { city: "FES", latitude: 34.0333333, longitude: -5.0, gmtWinter: 1, gmtSummer: 0 },
    { city: "LAAYOUNE", latitude: 27.1536111, longitude: -13.2033333, gmtWinter: 1, gmtSummer: 0 },
    { city: "MARRAKECH", latitude: 31.631321, longitude: -8.012478, gmtWinter: 1, gmtSummer: 0 },
    { city: "OUARZAZATE", latitude: 30.91987, longitude: -6.893539, gmtWinter: 1, gmtSummer: 0 },
    { city: "OUJDA", latitude: 34.686667, longitude: -1.9113889, gmtWinter: 1, gmtSummer: 0 },
    { city: "TANGER", latitude: 35.766667, longitude: -5.8, gmtWinter: 1, gmtSummer: 0 }
  ]
},
{
  country: "Tunisia",
  zone: [
    { city: "SFAX", latitude: 34.745159, longitude: 10.7613, gmtWinter: 1, gmtSummer: 1 },
    { city: "TUNIS", latitude: 36.81881, longitude: 10.16596, gmtWinter: 1, gmtSummer: 1 }
  ]
},
{
  country: "Egypt",
  zone: [
    { city: "ALEXANDRIA", latitude: 31.245573, longitude: 29.999309, gmtWinter: 2, gmtSummer: 2 },
    { city: "CAIRO", latitude: 30.04449, longitude: 31.235695, gmtWinter: 2, gmtSummer: 2 },
    { city: "LUXOR", latitude: 25.748446, longitude: 32.607422, gmtWinter: 2, gmtSummer: 2 }
  ]
},
{
  country: "South Africa",
  zone: [
    { city: "BLOEMFONTE", latitude: -29.118349, longitude: 26.22492, gmtWinter: 2, gmtSummer: 2 },
    { city: "CAPE TOWN", latitude: -33.9248685, longitude: 18.4240553, gmtWinter: 2, gmtSummer: 2 },
    { city: "DURBAN", latitude: -29.857876, longitude: 31.027581, gmtWinter: 2, gmtSummer: 2 },
    { city: "JOHANNESB", latitude: -26.2041028, longitude: 28.0473051, gmtWinter: 2, gmtSummer: 2 },
    { city: "KIMBERLEY", latitude: -28.72929, longitude: 24.75404, gmtWinter: 2, gmtSummer: 2 },
    { city: "NELSPRUIT", latitude: -25.4658333, longitude: 30.9852778, gmtWinter: 2, gmtSummer: 2 },
    { city: "P ELIZABET", latitude: -33.93264, longitude: 25.56995, gmtWinter: 2, gmtSummer: 2 },
    { city: "PIETERMARI", latitude: -29.6006068, longitude: 30.3794118, gmtWinter: 2, gmtSummer: 2 },
    { city: "POLOKWANE", latitude: -23.8961708, longitude: 29.4486263, gmtWinter: 2, gmtSummer: 2 },
    { city: "PRETORIA", latitude: -25.73134, longitude: 28.21837, gmtWinter: 2, gmtSummer: 2 }
  ]
},

{
  country: "Saudi Arabia",
  zone: [
    { city: "ABHA", latitude: 18.220221, longitude: 42.50816, gmtWinter: 3, gmtSummer: 3 },
    { city: "DHAHRAN", latitude: 26.288768, longitude: 50.114103, gmtWinter: 3, gmtSummer: 3 },
    { city: "JEDDAH", latitude: 21.543333, longitude: 39.172778, gmtWinter: 3, gmtSummer: 3 },
    { city: "MECCA", latitude: 21.42738, longitude: 39.814838, gmtWinter: 3, gmtSummer: 3 },
    { city: "RIYADH", latitude: 24.711667, longitude: 46.724167, gmtWinter: 3, gmtSummer: 3 },
    { city: "TABUK", latitude: 28.390409, longitude: 36.5732, gmtWinter: 3, gmtSummer: 3 }
  ]
},
{
  country: "Bahrein",
  zone: [
    { city: "MANAMA", latitude: 26.216667, longitude: 50.583333, gmtWinter: 3, gmtSummer: 3 }
  ]
},
{
  country: "UAE",
  zone: [
    { city: "ABU DHABI", latitude: 24.466667, longitude: 54.366667, gmtWinter: 4, gmtSummer: 4 },
    { city: "AJMAN", latitude: 25.3995, longitude: 55.4796, gmtWinter: 4, gmtSummer: 4 },
    { city: "DUBAI", latitude: 25.0476643, longitude: 55.1817407, gmtWinter: 4, gmtSummer: 4 },
    { city: "FUJAIRAH", latitude: 25.116667, longitude: 56.35, gmtWinter: 4, gmtSummer: 4 },
    { city: "RAS AL KH", latitude: 25.783333, longitude: 55.95, gmtWinter: 4, gmtSummer: 4 },
    { city: "SHARJAH", latitude: 25.366667, longitude: 55.383333, gmtWinter: 4, gmtSummer: 4 },
    { city: "UMM AL QU", latitude: 25.5132336, longitude: 55.5690835, gmtWinter: 4, gmtSummer: 4 }
  ]
},
{
  country: "Iran",
  zone: [
    { city: "ISFAHAN", latitude: 32.65139, longitude: 51.679192, gmtWinter: 3, gmtSummer: 3 },
    { city: "KERMAN", latitude: 30.28027, longitude: 57.06702, gmtWinter: 3, gmtSummer: 3 },
    { city: "MASHHAD", latitude: 36.3, longitude: 59.6, gmtWinter: 3, gmtSummer: 3 },
    { city: "QOM", latitude: 34.65, longitude: 50.883333, gmtWinter: 3, gmtSummer: 3 },
    { city: "SHIRAZ", latitude: 29.616667, longitude: 52.533333, gmtWinter: 3, gmtSummer: 3 },
    { city: "TABRIZ", latitude: 38.080978, longitude: 46.290119, gmtWinter: 3, gmtSummer: 3 },
    { city: "TEHRAN", latitude: 35.696111, longitude: 51.423056, gmtWinter: 3, gmtSummer: 3 }
  ]
},
{
  country: "Jordan",
  zone: [
    { city: "AMMAN", latitude: 31.956578, longitude: 35.945695, gmtWinter: 2, gmtSummer: 3 },
    { city: "AQABA", latitude: 29.53192, longitude: 35.006084, gmtWinter: 2, gmtSummer: 3 },
    { city: "IRBID", latitude: 32.545442, longitude: 35.857153, gmtWinter: 2, gmtSummer: 3 },
    { city: "AL ZARQA", latitude: 32.080953, longitude: 36.1058544, gmtWinter: 2, gmtSummer: 3 }
  ]
},
{
  country: "Lebanon",
  zone: [
    { city: "BEIRUT", latitude: 33.888629, longitude: 35.495479, gmtWinter: 2, gmtSummer: 3 },
    { city: "TRIPOLI", latitude: 34.438094, longitude: 35.830837, gmtWinter: 2, gmtSummer: 3 }
  ]
},
{
  country: "Qatar",
  zone: [
    { city: "DOHA", latitude: 25.280282, longitude: 51.522476, gmtWinter: 3, gmtSummer: 3 }
  ]
},
{
  country: "Syria",
  zone: [
    { city: "ALEPPO", latitude: 36.215549, longitude: 37.159279, gmtWinter: 2, gmtSummer: 2 },
    { city: "DAMASCUS", latitude: 33.519299, longitude: 36.31345, gmtWinter: 2, gmtSummer: 2 },
    { city: "HOMS", latitude: 34.733333, longitude: 36.716667,  gmtWinter: 2, gmtSummer: 2 }
  ]
},
{
  country: "Israel",
  zone: [
    { city: "JERUSALEM", latitude: 31.768318, longitude: 35.213711, gmtWinter: 2, gmtSummer: 3 },
    { city: "TEL AVIV", latitude: 32.066157, longitude: 34.777821, gmtWinter: 2, gmtSummer: 3 }
  ]
},
{country: "Bielarus",
  zone: [
    { city: "BREST", latitude: 52.3825, longitude: 25.199722222222224, gmtWinter: 3, gmtSummer: 3 },
    { city: "GOMEL", latitude: 52.44166666666666, longitude: 30.983333333333334, gmtWinter: 3, gmtSummer: 3 },
    { city: "GRODNO", latitude: 53.666666666666664, longitude: 23.816666666666666, gmtWinter: 3, gmtSummer: 3 },
    { city: "MAGUILOV", latitude: 53.916666666666664, longitude: 30.35, gmtWinter: 3, gmtSummer: 3 },
    { city: "MINSK", latitude: 53.90222222222222, longitude: 27.561944444444446, gmtWinter: 3, gmtSummer: 3 },
    { city: "VITEBSK", latitude: 55.18333333333333, longitude: 30.166666666666668, gmtWinter: 3, gmtSummer: 3 }
  ]
},
{
  country: "Hungary",
  zone: [
    { city: "BUDAPEST", latitude: 47.497912, longitude: 19.040235, gmtWinter: 1, gmtSummer: 2 },
    { city: "DEBRECEN", latitude: 47.5316049, longitude: 21.6273123, gmtWinter: 1, gmtSummer: 2 },
    { city: "GYOR", latitude: 47.6874569, longitude: 17.6503974, gmtWinter: 1, gmtSummer: 2 },
    { city: "MISKOLC", latitude: 48.0963631, longitude: 20.762386, gmtWinter: 1, gmtSummer: 2 },
    { city: "NYIREGYHAZ", latitude: 47.9495324, longitude: 21.7244053, gmtWinter: 1, gmtSummer: 2 },
    { city: "PECS", latitude: 46.0727345, longitude: 18.232266, gmtWinter: 1, gmtSummer: 2 },
    { city: "SZEGED", latitude: 46.2530102, longitude: 20.1414253, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Russia",
  zone: [
    { city: "CELJABINSK", latitude: 55.201612, longitude: 61.43839, gmtWinter: 6, gmtSummer: 6 },
    { city: "EKATERINB", latitude: 56.85, longitude: 60.6, gmtWinter: 6, gmtSummer: 6 },
    { city: "IRKUTSK", latitude: 52.2833333, longitude: 104.3, gmtWinter: 9, gmtSummer: 9 },
    { city: "KALININGRA", latitude: 54.7, longitude: 20.5, gmtWinter: 3, gmtSummer: 3 },
    { city: "KAZAN", latitude: 55.800556, longitude: 49.105556, gmtWinter: 4, gmtSummer: 4 },
    { city: "KOMSOMOLSK", latitude: 50.5666667, longitude: 137, gmtWinter: 11, gmtSummer: 11 },
    { city: "KRASNODAR", latitude: 45.0333333, longitude: 38.9666667, gmtWinter: 4, gmtSummer: 4 },
    { city: "MOSKVA", latitude: 55.75, longitude: 37.616667, gmtWinter: 4, gmtSummer: 4 },
    { city: "NIZHNIY NO", latitude: 56.316667, longitude: 44.0, gmtWinter: 4, gmtSummer: 4 },
    { city: "NORIL SK", latitude: 69.3333333, longitude: 88.2166667, gmtWinter: 7, gmtSummer: 7 },
    { city: "NOVOSIBIRS", latitude: 55.033333, longitude: 82.916667, gmtWinter: 7, gmtSummer: 7 },
    { city: "OMSK", latitude: 54.983333, longitude: 73.366667, gmtWinter: 4, gmtSummer: 4 },
    { city: "PERM", latitude: 58.0, longitude: 56.25, gmtWinter: 6, gmtSummer: 6 },
    { city: "SAMARA", latitude: 53.241504, longitude: 50.221246, gmtWinter: 4, gmtSummer: 4 },
    { city: "SAN PETERS", latitude: 59.9342802, longitude: 30.3350986, gmtWinter: 4, gmtSummer: 4 },
    { city: "SEVERODVIN", latitude: 64.5666667, longitude: 39.8166667, gmtWinter: 4, gmtSummer: 4 },
    { city: "TOMSK", latitude: 56.5, longitude: 84.9666667, gmtWinter: 7, gmtSummer: 7 },
    { city: "UFA", latitude: 54.783333, longitude: 56.033333, gmtWinter: 6, gmtSummer: 6 },
    { city: "VORKUTA", latitude: 67.5140734, longitude: 64.083795, gmtWinter: 4, gmtSummer: 4 },
    { city: "YAKUTSK", latitude: 62.0380757, longitude: 129.7293766, gmtWinter: 10, gmtSummer: 10 }
  ]
},
{
  country: "Romania",
  zone: [
    { city: "BRASOV", latitude: 45.65, longitude: 25.6, gmtWinter: 2, gmtSummer: 3 },
    { city: "BUCURESTI", latitude: 44.4, longitude: 26.083333333333332, gmtWinter: 2, gmtSummer: 3 },
    { city: "CLUJ-NAPOC", latitude: 46.78, longitude: 23.559444444444445, gmtWinter: 2, gmtSummer: 3 },
    { city: "CONSTANTA", latitude: 44.17333333333333, longitude: 28.638333333333332, gmtWinter: 2, gmtSummer: 3 },
    { city: "CRAIOVA", latitude: 44.333333333333336, longitude: 23.816666666666666, gmtWinter: 2, gmtSummer: 3 },
    { city: "GALATI", latitude: 45.42333333333333, longitude: 28.0425, gmtWinter: 2, gmtSummer: 3 },
    { city: "IASI", latitude: 47.16222222222222, longitude: 27.58888888888889, gmtWinter: 2, gmtSummer: 3 },
    { city: "TIMISOARA", latitude: 45.75972222222222, longitude: 21.229999999999997, gmtWinter: 2, gmtSummer: 3 }
  ]
},
{
  country: "Ukraine",
  zone: [
    { city: "DNIPROPETR", latitude: 48.45, longitude: 34.983333333333334, gmtWinter: 2, gmtSummer: 3 },
    { city: "DONETSK", latitude: 48.00888888888889, longitude: 37.80416666666667, gmtWinter: 2, gmtSummer: 3 },
    { city: "JARKOV", latitude: 50.0, longitude: 36.22916666666667, gmtWinter: 2, gmtSummer: 3 },
    { city: "KYIV", latitude: 50.45, longitude: 30.52361111111111, gmtWinter: 2, gmtSummer: 3 },
    { city: "LEOPOLIS", latitude: 49.830000000000005, longitude: 24.014166666666668, gmtWinter: 2, gmtSummer: 3 },
    { city: "ODESA", latitude: 46.46666666666667, longitude: 30.733333333333334, gmtWinter: 2, gmtSummer: 3 },
    { city: "ZAPORIYIA", latitude: 47.83777777777778, longitude: 35.138333333333335, gmtWinter: 2, gmtSummer: 3 }
  ]
},
{
  country: "Caribbean",
  zone: [
    { city: "BASSE TERRE", latitude: 15.998761, longitude: -61.725645, gmtWinter: -4, gmtSummer: -4 },
    { city: "BRIDGETOWN", latitude: 13.098938, longitude: -59.613352, gmtWinter: -4, gmtSummer: -4 },
    { city: "CAMAGÜEY", latitude: 21.3859, longitude: -77.913544, gmtWinter: -5, gmtSummer: -5 },
    { city: "CIENFUEGOS", latitude: 22.149969, longitude: -80.443679, gmtWinter: -5, gmtSummer: -5 },
    { city: "SANTIAGO", latitude: 20.028891, longitude: -75.828986, gmtWinter: -5, gmtSummer: -5 },
    { city: "F D FRANCE", latitude: 14.609371, longitude: -61.07256, gmtWinter: -4, gmtSummer: -4 },
    { city: "GONAÏVES", latitude: 19.45, longitude: -72.683333, gmtWinter: -5, gmtSummer: -5 },
    { city: "KINGSTON", latitude: 17.992731, longitude: -76.792008, gmtWinter: -5, gmtSummer: -5 },
    { city: "LA HABANA", latitude: 23.1168, longitude: -82.388556, gmtWinter: -5, gmtSummer: -5 },
    { city: "P PRINCIPE", latitude: 18.539269, longitude: -72.336408, gmtWinter: -5, gmtSummer: -5 },
    { city: "PORT SPAIN", latitude: 10.666666, longitude: -61.516666, gmtWinter: -4, gmtSummer: -4 },
    { city: "ST DOMINGO", latitude: 18.5, longitude: -69.983333, gmtWinter: -4, gmtSummer: -4 },
    { city: "RD-SANTIAG", latitude: 19.45565, longitude: -70.70719, gmtWinter: -4, gmtSummer: -4 },
    { city: "SAN JUAN", latitude: 18.466333, longitude: -66.105721, gmtWinter: -4, gmtSummer: -4 },
    { city: "ST GEORGES", latitude: 12.053532, longitude: -61.749684, gmtWinter: -4, gmtSummer: -4 }
  ]
},
{
  country: "Central America",
  zone: [
    { city: "BELMOPAN", latitude: 17.251388, longitude: -88.766944, gmtWinter: -6, gmtSummer: -6 },
    { city: "GUATEMALA", latitude: 14.624795, longitude: -90.532818, gmtWinter: -6, gmtSummer: -6 },
    { city: "MANAGUA", latitude: 12.136388, longitude: -86.251388, gmtWinter: -6, gmtSummer: -6 },
    { city: "PANAMA", latitude: 8.994268, longitude: -79.518791, gmtWinter: -5, gmtSummer: -5 },
    { city: "S SALVADOR", latitude: 13.706881, longitude: -89.20181, gmtWinter: -6, gmtSummer: -6 },
    { city: "SAN JOSE", latitude: 9.927128, longitude: -84.082011, gmtWinter: -6, gmtSummer: -6 },
    { city: "TEGUCIGALP", latitude: 14.0833, longitude: -87.2167, gmtWinter: -6, gmtSummer: -6 }
  ]
},
{
  country: "Mexico",
  zone: [
    { city: "CD MEXICO", latitude: 19.419444, longitude: -99.145556, gmtWinter: -6, gmtSummer: -5 },
    { city: "GUADALAJAR", latitude: 20.659698, longitude: -103.349609, gmtWinter: -6, gmtSummer: -5 },
    { city: "JUAREZ", latitude: 31.690363, longitude: -106.424547, gmtWinter: -7, gmtSummer: -6 },
    { city: "TIJUANA", latitude: 32.514946, longitude: -117.038247, gmtWinter: -8, gmtSummer: -7 },
    { city: "LEON", latitude: 21.125007, longitude: -101.68596, gmtWinter: -6, gmtSummer: -5 },
    { city: "MONTERREY", latitude: 25.671389, longitude: -100.308611, gmtWinter: -6, gmtSummer: -5 },
    { city: "CHIHUAHUA", latitude: 28.632995, longitude: -106.0691, gmtWinter: -7, gmtSummer: -6 },
    { city: "MERIDA", latitude: 20.96737, longitude: -89.592585, gmtWinter: -6, gmtSummer: -5 },
    { city: "ACAPULCO", latitude: 16.853108, longitude: -99.823653, gmtWinter: -6, gmtSummer: -5 }
  ]
},
{
  country: "Chile",
  zone: [
    { city: "ANTOFAGAST", latitude: -23.65, longitude: -70.4, gmtWinter: -4, gmtSummer: -3 },
    { city: "CONCEPCION", latitude: -36.818938, longitude: -73.050319, gmtWinter: -4, gmtSummer: -3 },
    { city: "RANCAGUA", latitude: -34.168052, longitude: -70.738965, gmtWinter: -4, gmtSummer: -3 },
    { city: "SANTIAGO", latitude: -33.416667, longitude: -70.55, gmtWinter: -4, gmtSummer: -3 },
    { city: "TALCAHUANO", latitude: -36.723928, longitude: -73.113099, gmtWinter: -4, gmtSummer: -3 },
    { city: "TEMUCO", latitude: -38.73383, longitude: -72.584496, gmtWinter: -4, gmtSummer: -3 },
    { city: "VALPARAISO", latitude: -33.045646, longitude: -71.620361, gmtWinter: -4, gmtSummer: -3 }
  ]
},
{
  country: "Uruguay",
  zone: [
    { city: "MONTEVIDEO", latitude: -34.8836111, longitude: -56.1819444, gmtWinter: -3, gmtSummer: -2 }
  ]
},
{
  country: "Peru",
  zone: [
    { city: "AREQUIPA", latitude: -16.398822, longitude: -71.536886, gmtWinter: -5, gmtSummer: -5 },
    { city: "LIMA", latitude: -12.093084, longitude: -77.046491, gmtWinter: -5, gmtSummer: -5 },
    { city: "TRUJILLO", latitude: -8.112, longitude: -79.0288, gmtWinter: -5, gmtSummer: -5 }
  ]
},
{
  country: "Poland",
  zone: [
    { city: "BIALYSTOK", latitude: 53.132489, longitude: 23.16884, gmtWinter: 1, gmtSummer: 2 },
    { city: "GDANSK", latitude: 54.352025, longitude: 18.646638, gmtWinter: 1, gmtSummer: 2 },
    { city: "KRAKOW", latitude: 50.06465, longitude: 19.94498, gmtWinter: 1, gmtSummer: 2 },
    { city: "LODZ", latitude: 51.759248, longitude: 19.455983, gmtWinter: 1, gmtSummer: 2 },
    { city: "LUBLIN", latitude: 51.246454, longitude: 22.568446, gmtWinter: 1, gmtSummer: 2 },
    { city: "POZNAN", latitude: 52.406374, longitude: 16.925168, gmtWinter: 1, gmtSummer: 2 },
    { city: "RZESZOW", latitude: 50.040947, longitude: 21.999281, gmtWinter: 1, gmtSummer: 2 },
    { city: "SZCZECIN", latitude: 53.428544, longitude: 14.552812, gmtWinter: 1, gmtSummer: 2 },
    { city: "WARSZAWA", latitude: 52.229676, longitude: 21.012229, gmtWinter: 1, gmtSummer: 2 },
    { city: "WROCLAW", latitude: 51.107885, longitude: 17.038538, gmtWinter: 1, gmtSummer: 2 },
    { city: "ZIELONA GO", latitude: 51.935621, longitude: 15.506186, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Slovenia",
  zone: [
    { city: "JESENICE", latitude: 46.436705, longitude: 14.052606, gmtWinter: 1, gmtSummer: 2 },
    { city: "KOPER", latitude: 45.548059, longitude: 13.730188, gmtWinter: 1, gmtSummer: 2 },
    { city: "LENDAVA", latitude: 46.564478, longitude: 16.453063, gmtWinter: 1, gmtSummer: 2 },
    { city: "LJUBLJANA", latitude: 46.051426, longitude: 14.505966, gmtWinter: 1, gmtSummer: 2 },
    { city: "MARIBOR", latitude: 46.557399, longitude: 15.645982, gmtWinter: 1, gmtSummer: 2 },
    { city: "NOVO MESTO", latitude: 45.801082, longitude: 15.171009, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Estonia",
  zone: [
    { city: "PÄRNU", latitude: 58.385808, longitude: 24.496577, gmtWinter: 2, gmtSummer: 3 },
    { city: "TALLINN", latitude: 59.436961, longitude: 24.753575, gmtWinter: 2, gmtSummer: 3 },
    { city: "TARTU", latitude: 58.380685, longitude: 26.725015, gmtWinter: 2, gmtSummer: 3 }
  ]
},
{
  country: "Lithuania",
  zone: [
    { city: "KAUNAS", latitude: 54.898496, longitude: 23.903542, gmtWinter: 2, gmtSummer: 3 },
    { city: "KLAIPEDA", latitude: 55.712622, longitude: 21.135219, gmtWinter: 2, gmtSummer: 3 },
    { city: "VILNIUS", latitude: 54.687156, longitude: 25.279651, gmtWinter: 2, gmtSummer: 3 }
  ]
},
{
  country: "Latvia",
  zone: [
    { city: "BAUSKA", latitude: 56.410288, longitude: 24.199999, gmtWinter: 2, gmtSummer: 3 },
    { city: "CESIS", latitude: 57.308611, longitude: 25.266872, gmtWinter: 2, gmtSummer: 3 },
    { city: "DAUGAVPILS", latitude: 55.874736, longitude: 26.536179, gmtWinter: 2, gmtSummer: 3 },
    { city: "JEKABPILS", latitude: 56.501455, longitude: 25.878299, gmtWinter: 2, gmtSummer: 3 },
    { city: "JELGAVA", latitude: 56.651109, longitude: 23.721354, gmtWinter: 2, gmtSummer: 3 },
    { city: "JURMALA", latitude: 56.953101, longitude: 23.721114, gmtWinter: 2, gmtSummer: 3 },
    { city: "LIEPAJA", latitude: 56.505635, longitude: 21.011906, gmtWinter: 2, gmtSummer: 3 },
    { city: "REZEKNE", latitude: 56.50761, longitude: 27.341814, gmtWinter: 2, gmtSummer: 3 },
    { city: "RIGA", latitude: 56.949649, longitude: 24.105186, gmtWinter: 2, gmtSummer: 3 },
    { city: "SALDUS", latitude: 56.665302, longitude: 22.492169, gmtWinter: 2, gmtSummer: 3 },
    { city: "SIGULDA", latitude: 57.149563, longitude: 24.860333, gmtWinter: 2, gmtSummer: 3 },
    { city: "TALSI", latitude: 57.248041, longitude: 22.587386, gmtWinter: 2, gmtSummer: 3 },
    { city: "TUKUMS", latitude: 56.969664, longitude: 23.15319, gmtWinter: 2, gmtSummer: 3 },
    { city: "VALMIERA", latitude: 57.535213, longitude: 25.421751, gmtWinter: 2, gmtSummer: 3 },
    { city: "VENTSPILS", latitude: 57.393722, longitude: 21.564707, gmtWinter: 2, gmtSummer: 3 }
  ]
},
{
  country: "Ukraine",
  zone: [
    { city: "DNEPROPETR", latitude: 48.464717, longitude: 35.046183, gmtWinter: 2, gmtSummer: 3 },
    { city: "DONETSK", latitude: 48.015883, longitude: 37.80285, gmtWinter: 2, gmtSummer: 3 },
    { city: "IVANO-FRAN", latitude: 48.922633, longitude: 24.711117, gmtWinter: 2, gmtSummer: 3 },
    { city: "KHARKIV", latitude: 49.9935, longitude: 36.230383, gmtWinter: 2, gmtSummer: 3 },
    { city: "KHMELNITSK", latitude: 49.422983, longitude: 26.987133, gmtWinter: 2, gmtSummer: 3 },
    { city: "KYIV", latitude: 50.4501, longitude: 30.5234, gmtWinter: 2, gmtSummer: 3 },
    { city: "L VIV", latitude: 49.839683, longitude: 24.029717, gmtWinter: 2, gmtSummer: 3 },
    { city: "ODESSA", latitude: 46.484583, longitude: 30.7326, gmtWinter: 2, gmtSummer: 3 },
    { city: "SIMFEROPOL", latitude: 44.952117, longitude: 34.102417, gmtWinter: 2, gmtSummer: 3 },
    { city: "UZHHOROD", latitude: 48.6208, longitude: 22.287883, gmtWinter: 2, gmtSummer: 3 }
  ]
},
{
  country: "Bosnia and Herzegovina",
  zone: [
    { city: "BIHAC", latitude: 44.819598, longitude: 15.870789, gmtWinter: 1, gmtSummer: 2 },
    { city: "MOSTAR", latitude: 43.342273, longitude: 17.812753, gmtWinter: 1, gmtSummer: 2 },
    { city: "SARAJEVO", latitude: 43.856258, longitude: 18.413076, gmtWinter: 1, gmtSummer: 2 },
    { city: "TUZLA", latitude: 44.5374611, longitude: 18.6734688, gmtWinter: 1, gmtSummer: 2 },
    { city: "ZENICA", latitude: 44.2, longitude: 17.933333, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Croatia",
  zone: [
    { city: "OSIJEK", latitude: 45.554962, longitude: 18.695514, gmtWinter: 1, gmtSummer: 2 },
    { city: "PULA", latitude: 44.866623, longitude: 13.849578, gmtWinter: 1, gmtSummer: 2 },
    { city: "SPLIT", latitude: 43.508132, longitude: 16.440193, gmtWinter: 1, gmtSummer: 2 },
    { city: "VARAZDIN", latitude: 46.305746, longitude: 16.336606, gmtWinter: 1, gmtSummer: 2 },
    { city: "ZADAR", latitude: 44.119392, longitude: 15.232911, gmtWinter: 1, gmtSummer: 2 },
    { city: "ZAGREB", latitude: 45.813029, longitude: 15.977894, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Macedonia",
  zone: [
    { city: "BEROVO", latitude: 41.666192, longitude: 22.762882, gmtWinter: 1, gmtSummer: 2 },
    { city: "OHRID", latitude: 41.12162, longitude: 20.81944, gmtWinter: 1, gmtSummer: 2 },
    { city: "PRILEP", latitude: 41.346389, longitude: 21.554167, gmtWinter: 1, gmtSummer: 2 },
    { city: "SKOPJE", latitude: 41.997346, longitude: 21.427995, gmtWinter: 1, gmtSummer: 2 }
  ]
},
{
  country: "Serbia",
  zone: [
    { city: "BEOGRAD", latitude: 44.820555, longitude: 20.462222, gmtWinter: 1, gmtSummer: 2 },
    { city: "KRAGUJEVAC", latitude: 44.012711, longitude: 20.92674, gmtWinter: 1, gmtSummer: 2 },
    { city: "LESKOVAC", latitude: 43.0, longitude: 21.95, gmtWinter: 1, gmtSummer: 2 },
    { city: "NIS", latitude: 43.31938, longitude: 21.896328, gmtWinter: 1, gmtSummer: 2 },
    { city: "NOVI SAD", latitude: 45.262231, longitude: 19.851857, gmtWinter: 1, gmtSummer: 2 },
    { city: "SOMBOR", latitude: 45.78, longitude: 19.12, gmtWinter: 1, gmtSummer: 2 }
  ]
},

];
